import React, { useState } from 'react';
import {
  getDocs, query, collection, where, doc, getDoc, updateDoc, increment
} from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { useTranslation } from 'react-i18next';

const RetailClaimForm = ({ customerId, retailOffers, offerData, setOfferData, onClaimed }) => {
  const [offerId, setOfferId] = useState('');
  const [quantity, setQuantity] = useState('');
  const [pin, setPin] = useState('');
  const { t } = useTranslation();

  const verifyPin = async (pin) => {
    const snap = await getDocs(query(collection(db, 'admin_users'), where('pin', '==', pin)));
    return !snap.empty;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!(await verifyPin(pin))) {
      alert(t('invalid_admin_pin'));
      return;
    }

    const offer = retailOffers.find(o => o.id === offerId);
    if (!offer) return;

    const docRef = doc(db, 'customer_offers', `${customerId}_${offerId}`);
    const docSnap = await getDoc(docRef);
    const data = docSnap.exists() ? docSnap.data() : { retail_spent: 0, claimed_discounts: 0 };

    const spent = data.retail_spent || 0;
    const requirement = offer.min_requirement || 1;
    const discountVal = offer.discount_value || 0;
    const claimedAmount = data.claimed_discounts || 0;
    
    // 🧮 Calculate total earned discount value
    const totalEarned = offer.discount_type === 'fixed'
      ? Math.floor(spent / requirement) * discountVal
      : Math.floor(spent * discountVal / 100);
    
    // 🎯 Unclaimed = earned - already claimed
    const unclaimedValue = totalEarned - claimedAmount;
    
    // 🔒 Validate claim amount (quantity = money in €)
    const claimAmount = Number(quantity);
    if (claimAmount <= 0 || claimAmount > unclaimedValue) {
      alert(`${t('unclaimed')}: ${unclaimedValue}`);
      return;
    }
    
    // ✅ Update claimed amount (monetary value)
    await updateDoc(docRef, {
      claimed_discounts: increment(claimAmount)
    });
    
    setOfferData(prev => ({
      ...prev,
      [offerId]: {
        ...prev[offerId],
        claimed_discounts: claimedAmount + claimAmount,
      },
    }));
    
    setOfferId('');
    setQuantity('');
    setPin('');
    onClaimed(t('claim_success', { count: claimAmount }));
  };
  return (
    <form onSubmit={handleSubmit} className="form-section">
      <h2>{t('claim_reward')}</h2>
      <select value={offerId} onChange={e => setOfferId(e.target.value)} required>
        <option value="">{t('select_offer')}</option>
        {retailOffers.map(o => (
          <option key={o.id} value={o.id}>{o.title}</option>
        ))}
      </select>
      <input
        type="number"
        placeholder={t('retail.number_to_claim')}
        value={quantity}
        onChange={e => setQuantity(e.target.value)}
        required
      />
      <input
        type="password"
        placeholder={t('admin_pin')}
        value={pin}
        onChange={e => setPin(e.target.value)}
        required
      />
      <button type="submit">{t('submit_claim')}</button>
    </form>
  );
};

export default RetailClaimForm;